import { PathUtils } from '@adobe/aem-spa-page-model-manager';
import { getAcquisitionFlow } from '../utils/acquisition-utils';
import SessionStorage from '../utils/SessionStorage';

interface IPageInfo {
    previousPage: string[];
    session: string;
}

const useAcquisitionsPreload = () => {
    const getPageName = () => {
        const path = window.location.pathname;
        const pathParts = path.replace('.html', '').split('/');
        return pathParts.pop() || '';
    };

    const checkIfValidFlow = (pageInfo: IPageInfo, previousPage: string) => {
        if (!pageInfo) {
            return true;
        }
        let validPreviousPage = true;
        const pageQueryParams = new URLSearchParams(window.location.search);
        if (
            window.location.pathname.includes('/pre-approved/application/application-fulfillment') &&
            !window.location.pathname.includes('application-fulfillment-verification') &&
            pageQueryParams.has('ApcID') &&
            pageQueryParams.has('zip')
        ) {
            return true;
        } else if (
            window.location.pathname.includes('ID-verify') &&
            pageQueryParams.has('sid')
        ) {
            return true;
        }
        if (pageInfo.previousPage) {
            validPreviousPage = pageInfo.previousPage.includes(previousPage);
        }
        return validPreviousPage;
    };

    if (PathUtils.getMetaPropertyValue('useAcquisitionPreload') === 'true') {
        const pageFlowAndDependencies: Record<string, any> = JSON.parse(PathUtils.getMetaPropertyValue('pageFlowAndDependencies') as string);

        const currentPage = getPageName();
        const previousPage = SessionStorage.tryGet('lastVisitedPage', '');
        SessionStorage.set('lastVisitedPage', currentPage as string);

        if (!currentPage || currentPage === previousPage) {
            return true;
        }

        const flow = getAcquisitionFlow();
        const pageFlow = pageFlowAndDependencies[flow];
        if (!pageFlow) {
            return true;
        }

        const pageInfo: IPageInfo = pageFlow[currentPage];
        return checkIfValidFlow(pageInfo, previousPage as string);
    }

    return true;
};

export default useAcquisitionsPreload;